// extracted by mini-css-extract-plugin
export default {"foremanToster":"ForemanCallToster_foremanToster__GP8A7","foremanTosterText":"ForemanCallToster_foremanTosterText__shLme"};